import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["legendId", "legendText", "invalid", "children", "className", "message", "messageText", "hasMargin"];
/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import classnames from 'classnames';
import { useFeatureFlag } from '../FeatureFlags';
import { usePrefix } from '../../internal/usePrefix';

var FormGroup = function FormGroup(_ref) {
  var legendId = _ref.legendId,
      legendText = _ref.legendText,
      invalid = _ref.invalid,
      children = _ref.children,
      className = _ref.className,
      message = _ref.message,
      messageText = _ref.messageText,
      hasMargin = _ref.hasMargin,
      other = _objectWithoutProperties(_ref, _excluded);

  var prefix = usePrefix();
  var enabled = useFeatureFlag('enable-v11-release');
  var classNamesLegend = classnames("".concat(prefix, "--label"), [enabled ? null : className]); // TODO - remove `fieldset--no-margin` in v11

  var classNamesFieldset = classnames("".concat(prefix, "--fieldset"), className, _defineProperty({}, "".concat(prefix, "--fieldset--no-margin"), !hasMargin));
  return /*#__PURE__*/React.createElement("fieldset", _extends({}, invalid && {
    'data-invalid': ''
  }, {
    className: classNamesFieldset
  }, other, {
    "aria-labelledby": other['aria-labelledby'] || legendId
  }), /*#__PURE__*/React.createElement("legend", {
    className: classNamesLegend,
    id: legendId || other['aria-labelledby']
  }, legendText), children, message ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "--form__requirements")
  }, messageText) : null);
};

FormGroup.defaultProps = {
  invalid: false,
  message: false,
  messageText: '',
  hasMargin: true
};
export default FormGroup;